import { useEffect } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { PageContent } from '@/components/page-content'
import { PageHeader } from '@/components/page-header'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { TableSkeleton } from '@/components/ui/table'
import { AutomationDrawer } from '@/features/automations/components/automation-drawer'
import { AddButton } from '@/features/jobs/edit/stages/add-button'
import { StagesDataTable } from '@/features/jobs/edit/stages/data-table'
import { setFrom } from '@/hooks/use-automation-store'
import { useOrganizationId } from '@/hooks/use-organization-id'
import { jobsStagesQuery } from '@/queries/use-jobs-queries'
export const Route = createFileRoute('/_authenticated/jobs_/$jobId_/edit/stages')({
  component: JobStages,
  loader: async ({ context: { queryClient }, params: { jobId } }) =>
    await queryClient.ensureQueryData(jobsStagesQuery(jobId)),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton cta title="Stages" />
      <PageContent>
        <TableSkeleton />
      </PageContent>
    </>
  ),
  validateSearch: z.object({
    automationId: z.string().optional(),
    stageId: z.string().optional(),
    step: z
      .enum([
        'comment',
        'create',
        'email-candidate',
        'email-recruiter',
        'schedule-interview',
        'show',
        'task-recruiter',
        'tag',
        'webhook',
      ])
      .optional(),
  }),
})

function JobStages() {
  const { jobId } = Route.useParams()
  const { data } = useSuspenseQuery(jobsStagesQuery(jobId))
  const { setOrganizationId } = useOrganizationId()
  setFrom('stages')

  useEffect(() => {
    setOrganizationId(data.organizationId)
  }, [setOrganizationId, data.organizationId])

  return (
    <>
      <PageHeader cta={<AddButton />} title="Stages" />
      <PageContent>
        <StagesDataTable data={data} />
        <AutomationDrawer />
      </PageContent>
    </>
  )
}
